import { render, staticRenderFns } from "./ChannelSelectModal.vue?vue&type=template&id=620f8eeb&"
import script from "./ChannelSelectModal.vue?vue&type=script&lang=ts&"
export * from "./ChannelSelectModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports